/* Utils */
import { DataSerializeType } from '../../interceptors/dataSerializer';
import { AuthType } from '../../interceptors/auth';

/**
 * @param {import('axios').AxiosInstance} forgeRockAxiosInstance
 */
export default function device(forgeRockAxiosInstance) {
  /**
   * Gets registration code
   */
  async function getRegistrationCode() {
    return forgeRockAxiosInstance.post('/openam/oauth2/realms/root/realms/ssla/device/code', {
      response_type: 'device_code',
      scope: 'profile openid entitlements status',
    }, {
      dataSerializeType: DataSerializeType.FORM_URL_ENCODED,
    });
  }

  /**
   * @param deviceCode
   */
  async function loginDevice(deviceCode) {
    return forgeRockAxiosInstance.post('/openam/oauth2/realms/root/realms/ssla/access_token', {
      grant_type: 'http://oauth.net/grant_type/device/1.0',
      code: deviceCode,
    }, {
      dataSerializeType: DataSerializeType.FORM_URL_ENCODED,
      authType: AuthType.API_TOKEN_BASIC,
    });
  }

  /**
   * @param {string} accessToken
   */
  async function introspectAccessToken(accessToken) {
    return forgeRockAxiosInstance.post('/openam/oauth2/realms/root/realms/device/introspect', {
      token: accessToken,
    }, {
      dataSerializeType: DataSerializeType.FORM_URL_ENCODED,
    });
  }

  return {
    getRegistrationCode,
    loginDevice,
    introspectAccessToken,
  };
}
